module.exports = __webpack_public_path__ + "static/img/q3.ef2963f8.jpg";